<aside class="custom-scrollbar flex flex-column p-4 h-full">
  <img ngSrc="assets/images/logo.svg" alt="OSF Logo" height="36" width="106" priority />
  <osf-nav-menu class="mt-5" />
</aside>
